import React, { useEffect } from "react";
import { inject, observer } from 'mobx-react';
import MaterialTable, { MTableToolbar } from "material-table";
import ReportsMenu from '../ReportsMenu';
import { LoadingSpinner } from '../../LoadingSpinner/LoadingSpinner';
import { RenderPermissionGroups } from "../HelperFunctionsReporting";
import { UnmatchedEmployeesColumns, localization, exportCsv } from '../Constants';
import '../Reporting.css';
import Grid from "@material-ui/core/Grid";
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { Typography, IconButton } from '@material-ui/core';
import { HtmlTooltip } from "../../HtmlTooltip/HtmlTooltip";

const UnmatchedEmployeesTable = inject('RootStore')(observer(({ RootStore }) => {
    useEffect((() => {
        RootStore.reportingStore.setRenderSpinner(true)
        RootStore.reportingStore.getUnmatchedEmployees()
    }), [RootStore.reportingStore]);

    const TableOptions = {
        search: true,
        paging: true,
        exportButton: true,
        exportCsv: exportCsv,
        filtering: true,
        grouping: true,
        pageSize: 50,
        emptyRowsWhenPaging: false,
        pageSizeOptions: [10, 25, 50]
    }

    return (
        <div className="row">
            {RootStore.reportingStore.renderSpinner && <LoadingSpinner text='Loading reports' />}
            <ReportsMenu />
            <div className="col-sm-9" id="report-table">
                <div>
                    {<MaterialTable
                        title=""
                        data={RootStore.reportingStore.unmatchedEmployees}
                        columns={UnmatchedEmployeesColumns}
                        options={TableOptions}
                        localization={localization}
                        onRowClick={(event, rowData, togglePanel) => togglePanel()}
                        detailPanel={[
                            {
                                tooltip: 'Show PGs',
                                render: rowData => RenderPermissionGroups(rowData),
                            },
                        ]}
                        components={{
                            Toolbar: (props) => (
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="flex-start"
                                    alignItems="center"
                                    spacing={3}
                                >
                                    <Grid item sm={3}>
                                        <h4 style={{ marginLeft: '10px' }}>
                                            Not Recognized Users
                                        </h4>
                                    </Grid>
                                    <Grid item sm={4} style={{ textAlign: 'right' }}>
                                        <h4>{new Date(RootStore.accountStore.oldestAccountUpdatedDate).toUTCString()}</h4>
                                        ({new Date(RootStore.accountStore.oldestAccountUpdatedDate).toLocaleString()} local time)
                                    </Grid>
                                    <HtmlTooltip
                                        title={
                                            <React.Fragment>
                                                <Typography color="inherit" variant="caption">
                                                    This is the last successful update date for all systems.
                                                </Typography>
                                            </React.Fragment>
                                        }
                                    >
                                        <IconButton aria-label="delete" size="small">
                                            <HelpOutlineIcon fontSize="inherit" />
                                        </IconButton>
                                    </HtmlTooltip>
                                    <Grid item sm={4} style={{ textAlign: 'left' }}>
                                        <MTableToolbar {...props} />
                                    </Grid>
                                </Grid>
                            )
                        }}
                    />}
                </div>
            </div>
        </div>
    )
}));

export default UnmatchedEmployeesTable;